"use client"
// import PropTypes from "prop-types"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { Col, Row, Input, Form, FormFeedback, Button, Spinner, Table, CardTitle, FormGroup } from "reactstrap";
import { Label, InputGroup, Card, CardBody, Tooltip } from "reactstrap";
import * as Yup from "yup";
import { useFormik, FieldArray, FormikProvider } from "formik";
import fn_helper from "helpers/fn_helper";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import MyEditor from "components/MyEditor";
import MyEditorCompact from "components/MyEditorCompact";

const CardDetail = ({
    pageView,
    validation,
    cardNumber,
    contentNumber,
    contentCardShow,
    runningNo = 0,
    colMd = 6,
    img1Whdth = 80,
    img1Height = 80,
}) => {
    // let cardRef = useRef(null);

    // useEffect(() => {
    //     if (cardRef !== null) {
    //         cardRef.current.checked = contentCardShow;
    //     }
    // }, [cardRef])

    const checkValue = validation?.values[`content${contentNumber}Card${cardNumber}Show`] ?? false

    return (
        <>
            <Col md={colMd}>
                <Card color="light">
                    <CardBody className="p-2">
                        <CardTitle className="m-0">
                            {/* <FormGroup className="align-middle" switch> */}
                                {/* <Input
                                    innerRef={cardRef}
                                    id={`content${contentNumber}Card${cardNumber}Show`}
                                    type="switch"
                                    role="switch"
                                    name={`content${contentNumber}Card${cardNumber}Show`}
                                    checked={checkValue}
                                    onClick={e => {
                                        const oldValue = checkValue
                                        validation.setFieldValue(`content${contentNumber}Card${cardNumber}Show`, !oldValue)
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched[`content${contentNumber}Card${cardNumber}Show`] &&
                                            validation.errors[`content${contentNumber}Card${cardNumber}Show`]
                                            ? true
                                            : false
                                }
                                    disabled={pageView === "view"}
                                /> */}
                                <Label className="align-middle m-0" htmlFor={`content${contentNumber}Card${cardNumber}Show`}>Card {runningNo} {validation.values[`content${contentNumber}Card${cardNumber}Show`]}</Label>
                            {/* </FormGroup> */}
                        </CardTitle>
                    </CardBody>
                    <CardBody className="p-1">
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item p-2">
                                <Col md={12}>
                                    <PopupAttachment
                                        typeDetail="single"
                                        typeUpload="ImageMap"
                                        upload="Image"
                                        prefixName={`section-worldclass-content${contentNumber}card${cardNumber}`}
                                        label="Image"
                                        required={false}
                                        description="description"
                                        widthSize={img1Whdth}
                                        heightSize={img1Height}
                                        value={validation.values[`content${contentNumber}Card${cardNumber}Image`]}
                                        onChange={(value = {}, index) => {
                                            console.log("🚀 onChange ~ value:", value)
                                            console.log("🚀 onChange ~ index:", index)
                                            validation.setFieldValue(`content${contentNumber}Card${cardNumber}Image`, value)
                                        }}
                                        onRemove={(index) => {
                                            console.log("🚀 onChange ~ index:", index)
                                            validation.setFieldValue(`content${contentNumber}Card${cardNumber}Image`, {})
                                        }}
                                    />
                                    {validation.touched[`content${contentNumber}Card${cardNumber}Image`] && validation.errors[`content${contentNumber}Card${cardNumber}Image`] && (
                                        <div type="invalid" className="invalid-feedback d-block">
                                            {validation.errors[`content${contentNumber}Card${cardNumber}Image`]}
                                        </div>
                                    )}
                                </Col>
                            </li>
                            {/* <li className="list-group-item p-2">
                                <label
                                    htmlFor={`content${contentNumber}Card${cardNumber}Title`}
                                    className="col-md-12 col-form-label"
                                >
                                    Title
                                </label>
                                <div className="col-md-12">
                                    <Input
                                        id={`content${contentNumber}Card${cardNumber}Title`}
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        name={`content${contentNumber}Card${cardNumber}Title`}
                                        onChange={e => {
                                            validation.setFieldValue(
                                                `content${contentNumber}Card${cardNumber}Title`,
                                                e.target.value
                                            )
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values[`content${contentNumber}Card${cardNumber}Title`]}
                                        invalid={
                                            validation.touched[`content${contentNumber}Card${cardNumber}Title`] &&
                                                validation.errors[`content${contentNumber}Card${cardNumber}Title`]
                                                ? true
                                                : false
                                        }
                                        disabled={pageView === "view"}
                                    />
                                    {validation.touched[`content${contentNumber}Card${cardNumber}Title`] &&
                                        validation.errors[`content${contentNumber}Card${cardNumber}Title`] && (
                                            <FormFeedback type="invalid">
                                                {validation.errors[`content${contentNumber}Card${cardNumber}Title`]}
                                            </FormFeedback>
                                        )}
                                </div>
                            </li> */}

                            <li className="list-group-item p-2">
                                <Label
                                    htmlFor={`content${contentNumber}Card${cardNumber}Detail`}
                                    className="col-md-12 col-form-label"
                                >
                                    Detail
                                    <span className="t-require">*</span>
                                </Label>
                                <Col md={12}>
                                    <MyEditorCompact
                                        id={`content${contentNumber}Card${cardNumber}Detail`}
                                        placeholder=""
                                        name={`content${contentNumber}Card${cardNumber}Detail`}
                                        onChange={(e, editor) => {
                                            const data = editor.getData()
                                            validation.setFieldValue(
                                                `content${contentNumber}Card${cardNumber}Detail`,
                                                data
                                            )
                                            console.log({ e, editor, data })
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values[`content${contentNumber}Card${cardNumber}Detail`]}
                                        invalid={
                                            validation.touched[`content${contentNumber}Card${cardNumber}Detail`] &&
                                                validation.errors[`content${contentNumber}Card${cardNumber}Detail`]
                                                ? true
                                                : false
                                        }
                                        disabled={pageView === "view"}
                                        isError={
                                            validation.touched[`content${contentNumber}Card${cardNumber}Detail`] &&
                                                validation.errors[`content${contentNumber}Card${cardNumber}Detail`]
                                                ? true
                                                : false
                                        }
                                    />
                                </Col>
                            </li>
                        </ul>

                    </CardBody>
                </Card>
            </Col>
        </>
    )
}
export default CardDetail